import {useState} from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import {toast} from "react-hot-toast";
import {FaRegCopy} from "react-icons/fa";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";

export const APITokenPopup = ({apiToken}: {apiToken: string}) => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      open={open}
      onOpenChange={setOpen}
      variant="light"
      tooltipContent={
        <div className="d-flex align-items-center p-2">
          <CopyToClipboard
            text={apiToken}
            onCopy={() => {
              setOpen(false);
              toast.success("API Token copied to clipboard");
            }}
          >
            <Icon icon={FaRegCopy} className="me-2 cursor-pointer" />
          </CopyToClipboard>
          {apiToken}
        </div>
      }
    >
      <Button
        variant={"ghost"}
        className={"px-0 pulse-color-blue-600 text-nowrap pulseTextBodySmall"}
        onClick={() => setOpen((prev) => !prev)}
      >
        View API Token
      </Button>
    </Tooltip>
  );
};
